import { Five9Client } from './client';

export default function SetCallVariableFlow(variableGroup, variableName, variableValue, client = new Five9Client()){
  return client.fetchActiveCalls().then((calls) => {
    if(calls.data.length == 1){
      return client.fetchVariable(variableName, variableGroup).then((variable) => {
        if(variable){
          const call = calls.data[0]
          return client.postCallVariable(call.id, variable.id, variableValue)
        }else{
          return undefined;
        }
      });
    }
  })
}
window.SetCallVariableFlow = SetCallVariableFlow;
